module.exports = __webpack_public_path__ + "media/press/NEWheaderv2-317ab3da.png";